<template>
  <div class="social-block" :style="containerStyles">
    <div class="social-title" v-if="title">
      <h3 :style="titleStyles">{{ title }}</h3>
    </div>
    <div class="social-icons" :style="iconsContainerStyles">
      <a 
        v-for="(social, index) in socialLinks" 
        :key="index"
        :href="social.url || '#'"
        class="social-icon"
        :style="getIconStyles(social)"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i :class="social.icon"></i>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialBlock',
  props: {
    title: {
      type: String,
      default: '¡Síguenos en redes sociales!'
    },
    socialLinks: {
      type: Array,
      default: () => [
        { 
          name: 'Facebook', 
          icon: 'fab fa-facebook-f', 
          url: '#', 
          color: '#1877f2',
          backgroundColor: '#ffffff' 
        },
        { 
          name: 'Twitter', 
          icon: 'fab fa-twitter', 
          url: '#', 
          color: '#1da1f2',
          backgroundColor: '#ffffff' 
        },
        { 
          name: 'Instagram', 
          icon: 'fab fa-instagram', 
          url: '#', 
          color: '#e4405f',
          backgroundColor: '#ffffff' 
        },
        { 
          name: 'LinkedIn', 
          icon: 'fab fa-linkedin-in', 
          url: '#', 
          color: '#0077b5',
          backgroundColor: '#ffffff' 
        }
      ]
    },
    align: {
      type: String,
      default: 'center'
    },
    iconSize: {
      type: String,
      default: '24px'
    },
    iconSpacing: {
      type: String,
      default: '15px'
    },
    backgroundColor: {
      type: String,
      default: 'transparent'
    },
    padding: {
      type: String,
      default: '20px'
    },
    titleColor: {
      type: String,
      default: '#2c3e50'
    },
    titleSize: {
      type: String,
      default: '18px'
    }
  },
  computed: {
    containerStyles() {
      return {
        backgroundColor: this.backgroundColor,
        padding: this.padding,
        textAlign: this.align
      }
    },
    titleStyles() {
      return {
        color: this.titleColor,
        fontSize: this.titleSize,
        margin: '0 0 15px 0',
        fontWeight: '600'
      }
    },
    iconsContainerStyles() {
      return {
        display: 'flex',
        justifyContent: this.align === 'center' ? 'center' : 
                      this.align === 'right' ? 'flex-end' : 'flex-start',
        gap: this.iconSpacing,
        flexWrap: 'wrap'
      }
    }
  },
  methods: {
    getIconStyles(social) {
      return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: social.backgroundColor || '#ffffff',
        color: social.color || '#333333',
        fontSize: this.iconSize,
        textDecoration: 'none',
        border: `2px solid ${social.color || '#333333'}`,
        transition: 'all 0.3s ease',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }
    }
  }
}
</script>

<style scoped>
.social-block {
  width: 100%;
  margin: 10px 0;
}

.social-icon:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.2) !important;
}

/* Responsive para emails */
@media only screen and (max-width: 600px) {
  .social-icons {
    justify-content: center !important;
  }
  
  .social-icon {
    margin: 5px !important;
  }
}
</style> 